import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

import FFmpeg from './components/FFmpeg';
// import DemoLinkCard from './components/DemoLinkCard';
// import codepen from './assets/codepen.png';

const TESTDATA_URL = 'https://github.com/ffmpegwasm/testdata';

const CONFIGS = {
  'extract-audio':{
    // await ffmpeg.run('-i', name, '-vn', '-acodec', 'libmp3lame', 'output.mp3');
    args: ['-i', '<INPUT>', '-vn', '-acodec', 'libmp3lame', 'output.mp3'],
    inputTypeHuman: 'Video',
    outFilename: 'output.mp3',
    mediaType: 'audio/mp3',
  },
  x264: `
{
  args: ['-i', 'video.avi', '-c:v', 'libx264', 'video.mp4'],
  inFilename: 'video.avi',
  outFilename: 'video.mp4',
  mediaType: 'video/mp4',
}`.trim('\n'),
  libvpx: `
{
  args: ['-i', 'video.avi', '-c:v', 'libvpx', 'video.webm'],
  inFilename: 'video.avi',
  outFilename: 'video.webm',
  mediaType: 'video/webm',
}`.trim('\n'),
  lame: `
{
  args: ['-i', 'audio.wav', '-c:a', 'libmp3lame', 'audio.mp3'],
  inFilename: 'audio.wav',
  outFilename: 'audio.mp3',
  mediaType: 'audio/mp3',
}`.trim('\n'),
};

const useStyles = makeStyles({
  root: {
    margin: '48px 0px 48px 0px',
  },
  para: {
    margin: '16px 0px 24px 0px',
  },
  unsupportedCnt:{
    margin: "20px 0"
  }
});

function Demo(props) {
  const classes = useStyles();

  const IS_COMPATIBLE = typeof SharedArrayBuffer === 'function';
  return (
    !IS_COMPATIBLE ? (
          <Grid container justifyContent="center" className={classes.unsupportedCnt}>
            <Grid item xs={12} md={9}>
              <Alert severity="error">
                Your browser doesn't support SharedArrayBuffer, which is required to preform this action. <br/>
                Please use a <a href="https://caniuse.com/sharedarraybuffer" target="_blank">supported browser</a> to continue.
              </Alert>
            </Grid>
          </Grid>
        ) : (
          <>
            <FFmpeg {...CONFIGS[props.operation]}/>
          </>
        )
  );
}

export default Demo;
